import { ComponentPropsWithoutRef } from "react";
import * as styles from "./WrapperDrawnBorder.css";
import DrawnBorder from "~/assets/svgs/DrawnBorder";
import clsx from "clsx";

type WrapperProps = ComponentPropsWithoutRef<"div">;

export const WrapperDrawnBorder = ({
  children,
  className,
  ...props
}: WrapperProps) => {
  return (
    <div {...props} className={clsx(className, styles.container)}>
      <DrawnBorder className={styles.border({ topBorder: true })} />
      {children}
      <DrawnBorder className={styles.border({ topBorder: false })} />
    </div>
  );
};
